import { Flex } from '@mantine/core'

import { AssetsDebtChart } from '@/components/@Shared/AssetsDebtChart/AssetsDebtChart'
import { AssetsValueChart } from '@/components/@Shared/AssetsValueChart/AssetsValueChart'
import { Budget } from '@/components/@Shared/Budgets/Budgets'
import { DebtValueChart } from '@/components/@Shared/DebtValueChart/DebtValueChart'
import { IncomeSummary } from '@/components/@Shared/IncomeSummary/IncomeSummary'
import { SpendingSummary } from '@/components/@Shared/SpendingSummary/SpendingSummary'
import { TransactionSyncNotice } from '@/components/@Shared/TransactionSyncNotice/TransactionSyncNotice'
import { GoalsWidget } from '@/components/GoalsWidget/GoalsWidget'
import { Insights } from '@/components/Insights/Insights'

import { page as InsightPage } from '@/__generated__/requests'

import classes from './DashboardShell.module.css'

export function DashboardShell() {
  return (
    <>
      <TransactionSyncNotice mb={24} />

      <Insights page={InsightPage.DASHBOARD} staticMargin />

      <AssetsDebtChart />

      <Flex className={classes.incomeAssetsContainer}>
        <Flex className={classes.donutChartsContainer}>
          <AssetsValueChart />

          <DebtValueChart />
        </Flex>

        <Flex className={classes.summary}>
          <IncomeSummary />

          <SpendingSummary />
        </Flex>
      </Flex>

      <Flex className={classes.budgetActionsContainer}>
        <Budget />

        <GoalsWidget />
      </Flex>
    </>
  )
}
